import { render, staticRenderFns } from "./MdTrendChart.vue?vue&type=template&id=22dbd2d0&scoped=true&"
import script from "./MdTrendChart.vue?vue&type=script&lang=js&"
export * from "./MdTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./MdTrendChart.vue?vue&type=style&index=0&id=22dbd2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dbd2d0",
  null
  
)

export default component.exports